import { type Product } from "core/catalog";
import { parseError, useSubmitProps } from "core/shared";
import { userAtom } from "core/user";
import { wishlistAtom } from "core/wishlist";
import { action } from "framework/config/action";
import { URLS } from "framework/config/urls";
import { useState } from "react";

export function useAddToWishlist(
  product: Product,
  { onSuccess, onError }: useSubmitProps,
) {
  const submit = action(URLS.account.wishlist);

  const addToWishlist = async () => {
    const response = await submit({ product: product.id, action: "add" });

    if (response.isOK) {
      onSuccess?.(response.data);
    } else {
      onError?.(parseError(response));
    }
  };

  return { addToWishlist };
}

export function useRemoveFromWishlist(
  product: Product,
  { onSuccess, onError }: useSubmitProps,
) {
  const submit = action(URLS.account.wishlist);

  const removeFromWishlist = async () => {
    const response = await submit({ product: product.id, action: "remove" });

    if (response.isOK) {
      onSuccess?.(response.data);
    } else {
      onError?.(parseError(response));
    }
  };

  return { removeFromWishlist };
}

export function useToggleWishlist(
  product: Product,
  { onSubmit, onSuccess, onError }: useSubmitProps,
) {
  const [inWishlist, setInWishlist] = useState(product.inWishlist);
  // const products = productsListAtom.use("products");

  const { addToWishlist } = useAddToWishlist(product, {
    onSubmit,
    onSuccess: (response) => {
      setInWishlist(true);
      // const updatedProducts = products.map((p) =>
      //   p.id === product.id ? { ...p, inWishlist: true } : p,
      // );

      wishlistAtom.addProduct(product);
      // productsListAtom.change("products", updatedProducts);
      userAtom.update(response.user);
      onSuccess?.(response);
    },
    onError,
  });

  const { removeFromWishlist } = useRemoveFromWishlist(product, {
    onSubmit,
    onSuccess: (response) => {
      // const updatedProducts = products.map((p) =>
      //   p.id === product.id ? { ...p, inWishlist: false } : p,
      // );

      wishlistAtom.removeProduct(product);
      // productsListAtom.change("products", updatedProducts);
      userAtom.update(response.user);
      setInWishlist(false);
      onSuccess?.(response);
    },
    onError,
  });

  const toggleWishlist = async () => {
    if (inWishlist) {
      await removeFromWishlist();
    } else {
      await addToWishlist();
    }
  };

  return { inWishlist, toggleWishlist };
}

export function useClearWishlist({ onSuccess, onError }: useSubmitProps) {
  const submit = action(URLS.account.wishlist);

  const clearWishlist = async () => {
    const response = await submit({ action: "clear" });

    if (response.isOK) {
      onSuccess?.(response.data);
    } else {
      onError?.(parseError(response));
    }
  };

  return { clearWishlist };
}
